import React from "react";

const Banner = () => {
  return (
    <div className="banner">
      <h1>Chez vous, partout et ailleurs</h1>
    </div>
  );
};

export default Banner;
